<template>
    <div class="container pb-4 mb-4">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row">
      <div class="col"><h5>Articles</h5></div>
      <div class="col text-right pt-1">
        <i v-if="creating" class="fas fa-spinner fa-spin fa-1x"></i>
        <a v-else-if="user.account == 'Admin'" href="#/" @click="createArticle">Create new article</a>
        <a v-else href="#/" @click="completeProfile">Create new article</a>
    </div>
</div>

<b-card no-body>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Active" title-link-class="darklink">
          <b-card-text><admin-articles-list :status="4" :user="user" ref="AdminArticles4"></admin-articles-list></b-card-text>
        </b-tab>
        <b-tab title="Inactive" title-link-class="darklink">
          <b-card-text><admin-articles-list :status="3" :user="user" ref="AdminArticles3"></admin-articles-list></b-card-text>
        </b-tab>
        <b-tab title="In Review" title-link-class="darklink">
          <b-card-text><admin-articles-list :status="2" :user="user"></admin-articles-list></b-card-text>
        </b-tab>
        <b-tab title="Incomplete" title-link-class="darklink">
          <b-card-text><admin-articles-list :status="1" :user="user"></admin-articles-list></b-card-text>
        </b-tab>
        <b-tab title="Scheduled" title-link-class="darklink">
          <b-card-text><admin-articles-list :status="5" :user="user"></admin-articles-list></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

      </div>
    </div>
  </div>
</template> 

<script>

export default {
  props: ['user'],

  data() {
    return {
      tabIndex: 0,
      creating: false,
      uploading_file: false,
    };
  },

  methods: {

    updateArticleList() {
      console.log('updateArticleList');
      this.$refs.AdminArticles4.getArticles();
      this.$refs.AdminArticles3.getArticles();
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

    completeProfile() {
      this.sweetfire('Please complete your profile then you can create an article');
    },

    createArticle() {

      this.creating = true;

      axios
          .post('/articles/new', {})
          .then((response) => {
            
          window.open('/articles/edit/'+response.data, '_self');

          })
          .catch(function (err) {
            console.log(err);
            this.creating = false;
          });

    },
  
}

}
</script>

<style scoped>
td:hover {cursor: pointer;}
.application_image { width: 100%; border-radius: 0.25rem; }
</style>